// extracted by mini-css-extract-plugin
export var title = "style-module--title--fm4Rl";